<template>
<v-main  v-scroll="onScroll">
  <header-common :logo_background="backgroundUrl" :page_title="page_title" :onTop="onTop" v-on:editContent="editContent"></header-common>
  <v-container>
      <v-row>
          <v-col cols="12" md="9">
            <v-expansion-panels flat focusable>
              <v-expansion-panel style="border-bottom: 1px solid rgba(0,0,0,0.2);">
                <v-expansion-panel-header style="font-size: 20px; font-weight: 600;" @click="editContent('pages.faq.title_1')">{{ $vuetify.lang.t('$vuetify.pages.faq.title_1') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p @click="editContent('pages.faq.content_1')">{{ $vuetify.lang.t('$vuetify.pages.faq.content_1') }}</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel style="border-bottom: 1px solid rgba(0,0,0,0.2);" @click="editContent('pages.faq.title_2')">
                <v-expansion-panel-header style="font-size: 20px; font-weight: 600;">{{ $vuetify.lang.t('$vuetify.pages.faq.title_2') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  
                  <p @click="editContent('pages.faq.content_2')">{{ $vuetify.lang.t('$vuetify.pages.faq.content_2') }}</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel style="border-bottom: 1px solid rgba(0,0,0,0.2);">
                <v-expansion-panel-header style="font-size: 20px; font-weight: 600;"  @click="editContent('pages.faq.title_3')">{{ $vuetify.lang.t('$vuetify.pages.faq.title_3') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <p @click="editContent('pages.faq.content_3')">{{ $vuetify.lang.t('$vuetify.pages.faq.content_3') }}</p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <v-col cols="12" md="3">
            <div style="width:100%; height:fit-content; text-align:left; padding:0 30px; background: #003d90 url('https://demo.artureanec.com/html/transx/img/contact_background.png') bottom right no-repeat; background-size: 125px; padding-bottom:20px;clip-path: polygon(85% 0,100% 10%,100% 100%,0 100%,0 0);">
                <h2 style="color:white;font-weight:700; padding-top:20px;">{{ $vuetify.lang.t('$vuetify.pages.home.popup_contact_title') }}</h2>
                <p style="color:white;"></p>
                <v-btn dark outlined class="rounded-br-xl rounded-0" right style="margin-top:40px;">
                {{ $vuetify.lang.t('$vuetify.pages.home.popup_contact_btn') }}
                </v-btn>
            </div>
          </v-col>
      </v-row>
  </v-container>
  <footer-prime v-on:editContent="editContent"></footer-prime>
</v-main>
</template>

<script>
import headerCommon from "./commons/header"
import footerPrime from "./commons/footer"
import logo_light from "./../../assets/logo_light.png"
import logo_dark from "./../../assets/logo_dark.png"
import aboutImg from "./../../assets/section_1.jpg"
import aboutCart from "./../../assets/about_cart.png"

export default {
  name: 'faq',
  data: () => ({
      type: ['20" ', '40" '],
      inflammable: false,
      tabs: 'tab2',
      tab: null,
      gerbable: false,
      page_title: 'faq',
      backgroundUrl: logo_light,
      aboutImage: aboutImg,
      aboutCart: aboutCart,
      onTop: true,
      image: '',
      list: [
          {name: 'air-freight', title: 'Fret Aérien', image: 'https://www.centrimex.com/wp-content/uploads/2022/02/shutterstock_75182638_small-980x500.jpg'},
          {name: 'road-freight', title: 'Transport Terrestre', image: 'https://i.imgur.com/atYPuzt.jpg'},
          {name: 'sea-freight', title: 'Service Maritime', image: 'https://i.imgur.com/tzPdACy.jpg'},
          {name: 'ship-freight', title: 'Chartering', image: 'https://demo.artureanec.com/html/transx/img/box_4.jpg'},
      ],
      currentService: {}
    }),
    methods: {
      onScroll() {
        if(document.documentElement.scrollTop === 0 ){
          this.backgroundUrl = logo_light
          this.onTop = true
        }else{
          this.backgroundUrl = logo_dark
          this.onTop = false
        }
      },
      editContent(name){
        //console.log(name+' - index')
        this.$emit("edit", {name: name, page: 'FAQ'})
      },
    },
    components: {
      headerCommon, footerPrime
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');
.list-about .v-icon {
  padding-right:20px;
  color:#1976d2;
}
.list-about .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){
  color: rgb(65, 74, 82) !important;
  line-height:15px;
  padding-bottom: 10px;
}
.quotes {
    background: url('https://i.imgur.com/yOZlJRU.png') no-repeat top left;
    background-size: 80px;
}
.quote-content {
    font-size: 16px;
    line-height: 25px;
    padding: 35px;
}
.list-about .v-icon {
  padding-right:20px;
  color:#1976d2;
}
.step {
    text-align:left;
    color: white;
}
.feature-content{
  font-size: 14px;
  letter-spacing: 1px;
  padding-top: 10px;
  line-height: 26px;
}

.feature-title{
  padding-top: 0px;
  font-size: 18px;
  font-weight: 700;
}
.step-title {
    font-weight:700;
    font-size:18px;
    margin-bottom:15px;
    display: block;
}
.img-content {
    width:100%;
    height:550px;
    background-size:cover !important;
}
*{
  transition: all .3s ease-in;
}
.image-service{
    overflow: hidden;
}
.image-service:hover .img-content {
    transform: scale(1.2);
}
.service-position {
    font-size:36px;
    color: #41abff;
}
.description-service {
    position: absolute;
    bottom: 22px;
    left: 0;
    right: 0;
    width: 95%;
    padding: 0 30px 13px 30px;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    z-index: 1;
    font-size:20px;
    font-weight:700;
    color: white;
}
.text-service {
    position: absolute;
    top: 230px;
    left: 25px;
    color: #f3f6f5;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    -webkit-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg);
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: 1;
}

* {
  font-family: 'Inter', sans-serif;
}
.back-head{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255,255,255,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
.font-back-content{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(0,0,0,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
#header-website .v-btn{
  border-radius: 20px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.headline {
  font-size: 64px;
  text-shadow: 0 0 20px rgba(0,0,0,0.6);
  font-weight: 700;
}
.text-caption{
  width:50%;
  text-align: center;
  margin: 0 auto;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/website/faq.vue